export default [
  {
    key: "operator",
    label: "field.operator",
    rules: "required",
    type: "async-single-selection",
    repository: "callOperator",
    selectionKey: "id",
    selectionLabel: "name",
    clearable: true,
    lg: 4,
  },
  {
    key: "period",
    label: "field.date",
    type: "radio",
    options: [
      { text: "field.today", value: "today" },
      { text: "field.yesterday", value: "yesterday" },
      { text: "field.thisWeek", value: "thisWeek" },
      { text: "field.lastWeek", value: "lastWeek" },
      { text: "field.thisMonth", value: "thisMonth" },
      { text: "field.lastMonth", value: "lastMonth" },
      { text: "field.other", value: "other" },
    ],
    md: 12,
    lg: 8,
    skip: true,
  },
  {
    lg: 4,
  },
  {
    key: "startDate",
    label: "field.fromDate",
    type: "date",
    lg: 4,
  },
  {
    key: "endDate",
    label: "field.toDate",
    type: "date",
    lg: 4,
  },
];
